// import 'https://q5js.org/q5.js';

import './style.css';

import p5 from 'p5';

// 创建两个独立的控制器对象
window.dumplingControllers = {
  leader: {
    flip: null,
    speak: null,
  },
  follower: {
    flip: null,
    speak: null,
  },
};

const DumplingCommunicator = {
  commands: [],
  addCommand: function (command) {
    this.commands.push(command);
  },
  getCommands: function () {
    const commands = [...this.commands];
    this.commands = [];
    return commands;
  },
};

// 修改事件监听器，只控制leader饺子
const setupButtonListeners = () => {
  const flipBtn = document.getElementById('flip-btn');
  const speakBtn = document.getElementById('speak-btn');
  flipBtn.addEventListener('click', () => {
    if (window.dumplingControllers.leader.flip) {
      window.dumplingControllers.leader.flip();
    }
  });
  speakBtn.addEventListener('click', () => {
    if (window.dumplingControllers.leader.speak) {
      window.dumplingControllers.leader.speak();
    }
  });
};

import { createDumplingSketch } from './sketchDumplingP5';

const sketch1 = createDumplingSketch(DumplingCommunicator, 'leader', { isFrontFacing: false });
const sketch2 = createDumplingSketch(DumplingCommunicator, 'follower', { isFrontFacing: true });

// 分别创建两个canvas并指定挂载的DOM元素
const sketchElement1 = document.getElementById('sketch1');
const sketchElement2 = document.getElementById('sketch2');

// 实例化p5.js
new p5(sketch1, sketchElement1);
new p5(sketch2, sketchElement2);

document.addEventListener('DOMContentLoaded', setupButtonListeners);
